export const GET_LEAD_PROFILE_STICKY_COLUMNS = "GET_LEAD_PROFILE_STICKY_COLUMNS";
export const GET_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS = "GET_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS";
export const GET_LEAD_PROFILE_STICKY_COLUMNS_ERROR = "GET_LEAD_PROFILE_STICKY_COLUMNS_ERROR";

export const UPDATE_LEAD_PROFILE_STICKY_COLUMNS = "UPDATE_LEAD_PROFILE_STICKY_COLUMNS";
export const UPDATE_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS = "UPDATE_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS";
export const UPDATE_LEAD_PROFILE_STICKY_COLUMNS_ERROR = "UPDATE_LEAD_PROFILE_STICKY_COLUMNS_ERROR";